import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/app/hooks';
import { initAnalytics, trackPageView } from '@/services/analyticsService';
import Sidebar from '@/components/layout/Sidebar/Sidebar';
import Navbar from '@/components/layout/Navbar/Navbar';
import Toast from '@/components/ui/Toast/Toast';
import UploadModal from '@/components/ui/UploadModal/UploadModal';
import ClipSelectionBar from '@/components/ui/ClipSelectionBar/ClipSelectionBar';
import CreateSectionModal from '@/components/ui/CreateSectionModal/CreateSectionModal';
import AssignSectionModal from '@/components/ui/AssignSectionModal/AssignSectionModal';
import AssetDetailDrawer from '@/components/content/AssetDetailDrawer/AssetDetailDrawer';
import ContentEnrichmentModal from '@/components/ui/ContentEnrichmentModal/ContentEnrichmentModal';
import ErrorBoundary from '@/components/ui/ErrorBoundary/ErrorBoundary';
import MediaIntelligencePage from '@/pages/MediaIntelligencePage';
import LoginPage from '@/pages/LoginPage';
import SectionViewAllPage from '@/pages/SectionViewAllPage';
import styles from './App.module.css';

function HomePage() {
  const uploadModalOpen = useAppSelector((s) => s.ui.uploadModalOpen);
  const createModalOpen = useAppSelector((s) => s.sections.createModalOpen);
  const assignModalAssetId = useAppSelector((s) => s.sections.assignModalAssetId);
  const detailDrawerSeq = useAppSelector((s) => s.ui.detailDrawerSeq);
  const contentEnrichmentOpen = useAppSelector((s) => s.ui.contentEnrichmentOpen);
  return (
    <div className={styles.shell}>
      <Sidebar activeItem="library" />
      <div className={styles.main}>
        <Navbar />
        <MediaIntelligencePage />
      </div>
      <Toast />
      <ClipSelectionBar />
      <ErrorBoundary key={detailDrawerSeq}><AssetDetailDrawer /></ErrorBoundary>
      {uploadModalOpen && <UploadModal />}
      {createModalOpen && <CreateSectionModal />}
      {assignModalAssetId && <AssignSectionModal />}
      {contentEnrichmentOpen && <ContentEnrichmentModal />}
    </div>
  );
}

function SectionPage() {
  const uploadModalOpen = useAppSelector((s) => s.ui.uploadModalOpen);
  const createModalOpen = useAppSelector((s) => s.sections.createModalOpen);
  const assignModalAssetId = useAppSelector((s) => s.sections.assignModalAssetId);
  const detailDrawerSeq = useAppSelector((s) => s.ui.detailDrawerSeq);
  const contentEnrichmentOpen = useAppSelector((s) => s.ui.contentEnrichmentOpen);
  return (
    <div className={styles.shell}>
      <Sidebar activeItem="library" />
      <div className={styles.main}>
        <Navbar showSearch={false} />
        <SectionViewAllPage />
      </div>
      <Toast />
      <ClipSelectionBar />
      <ErrorBoundary key={detailDrawerSeq}><AssetDetailDrawer /></ErrorBoundary>
      {uploadModalOpen && <UploadModal />}
      {createModalOpen && <CreateSectionModal />}
      {assignModalAssetId && <AssignSectionModal />}
      {contentEnrichmentOpen && <ContentEnrichmentModal />}
    </div>
  );
}

function useHubspotPageViews() {
  const location = useLocation();
  useEffect(() => {
    initAnalytics();
  }, []);
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
}

export default function App() {
  useHubspotPageViews();
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/signin" element={<LoginPage />} />
      <Route path="/section/:sectionId" element={<SectionPage />} />
    </Routes>
  );
}
